import React from "react";
import { Col, Row } from "react-bootstrap";
import { ProductReferenceField } from "../../CompoundFields/ProductReferenceField";
import { DescriptionField } from "../../CompoundFields/DescriptionField";
import { FieldGroup } from "../../Groups/FieldGroup";
import { RadioField } from "../../Fields/RadioField";
import { Condition } from "../../Conditionals/Condition";
import { TextareaField } from "../../Fields/TextareaField";
import { FileField } from "../../Fields/FileField";
import { pickOne, requiredField, requiredUpload } from "../../Validation";

export const BoothLayout = () => {
    return <Row>
        <hr/>
        <Col md={ 12 }>
            <h2>Booth Layout</h2>
            <ProductReferenceField
                elementType="booth layout"
            />
        </Col>

        <DescriptionField
            parent="Booth layout"
        />

        <Col md={ 12 }>
            <FieldGroup
                groupName="Booth layout"
                groupId="BoothLayout"
                groupLabel="What kind of booth are you thinking of?"
                validator={ pickOne }
            >
                {/* ROLL UP (opens roll up form) */ }
                <RadioField
                    fieldId="Booth layout"
                    fieldLabel="With roll up"
                    fieldValue="Roll up"
                />

                {/* UMBRELLA (submit closes the form) */ }
                <RadioField
                    fieldId="Booth layout"
                    fieldLabel="With an umbrella booth"
                    fieldValue="Umbrella"
                />

                {/* CUSTOM (submit closes the form) */ }
                <RadioField
                    fieldId="Booth layout"
                    fieldLabel="Custom booth layout"
                    fieldValue="Custom"
                />
            </FieldGroup>
            <Condition when="Booth layout" is="Custom">
                <TextareaField
                    fieldId="Custom Booth Layout"
                    fieldLabel="Description"
                    fieldRequired={ true }
                    validator={ requiredField }
                />
            </Condition>
        </Col>

        <Col md={ 12 }>
            <FileField
                fileFieldId="boothLayout_file"
                fileFieldName="boothLayoutFile"
                fileFieldLabel="Upload materials and please describe your needs."
                fileFieldMultiple={ true }
                hint="Please attach any materials you have that will help us complete this project (e.g. Excel tables,
                images, Plans, renders, measurements, Word documents, PowerPoints, native design files, notes,
                videos, etc.)"
                validator={ requiredUpload }
            />
        </Col>
    </Row>;
}